import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { ComponentType } from "../../../constants";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import ComponentsService from "../../../services/ComponentsService";
import { INFINITE_PAGINATED_DATA_UPDATERS } from "../../../utils/optimisticUpdate";
import { COMPONENT_TEMPLATES_LIST_QUERY_KEY } from "../ComponentTemplateDialog";
import {
  ComponentTemplateDto,
  IPaginatedListOfComponentTemplateDto,
  PaginatedListOfComponentTemplateBriefDto,
} from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../../component-templates-library/ComponentTemplateLibrary";

// Use to delete component template from the sidebar
export const useDeleteComponentTemplateMutation = (
  componentType: ComponentType,
) => {
  const filterOutTemplate = INFINITE_PAGINATED_DATA_UPDATERS.filterOutItem;
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template removed",
    queryKey: [COMPONENT_TEMPLATES_LIST_QUERY_KEY, { componentType }],
    mutationFn: ComponentsService.removeComponentTemplate,
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfComponentTemplateBriefDto,
        variables,
        _,
      ) => {
        const updatedData = PaginatedListOfComponentTemplateBriefDto.fromJS({
          ...oldData,
          items: oldData.items.filter((item) => item.id !== variables),
        });

        return updatedData;
      },
    },
    options: {
      onSuccess(_, id) {
        queryClient.setQueryData(
          [COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY, { componentType }],
          (oldData: InfiniteData<IPaginatedListOfComponentTemplateDto>) => {
            if (!oldData) return oldData;

            return filterOutTemplate<ComponentTemplateDto>(oldData, id);
          },
        );
      },
    },
  });
};
